import { useState, useEffect } from 'react';
import { notNullOrEmpty, validEmail } from './../../utils/validators';

export const FloatingEmailInput = ({ label, email, updateCallback, className, required, validatorFn, readOnly, onClick }) => {

    const isValidLength = () => !!required ? notNullOrEmpty(email) : true;
    const isValidFormat = () => isValidLength() && validEmail(email);

    const [valueChanged, setValueChanged] = useState(notNullOrEmpty(email));

    useEffect(() => {
        setValueChanged(value => value || notNullOrEmpty(email));
    }, [email]);

    const validInput = () => {

        if (!valueChanged) {
            return true;
        }

        let valid = true;
        valid &&= isValidFormat();
        valid &&= valueChanged && !!validatorFn ? validatorFn(email) : true;
        return valid;
    };

    const style = validInput() ? {} : {
        borderColor: "red",
        color: "red"
    };

    const boxShadow = {
        boxShadow: '1px 2px 9px rgba(244, 170, 185, 1)'
    }

    return (
        <>
            <div className={`form-floating mb-3 mb-md-0 ${className}`}>
                <input onClick={() => { return onClick ? onClick() : () => { }}} readOnly={readOnly} required={required} style={validInput() ? style : { ...style, ...boxShadow }} type="email" className={`form-control fs-15px ${validInput() ? 'text-black-900' : 'text-red'} `} id="email" placeholder="name@example.com" value={email} onChange={e => updateCallback(e.target.value)} />
                <label htmlFor="email" className="d-flex align-items-center fs-13px text-black">{label ?? "Email address"}</label>
            </div>
            {valueChanged && <>
                <div className='mt-5px' style={isValidLength() ? { display: "none" } : style} >Email address is required</div>
                <div className='mt-5px' style={isValidFormat() ? { display: "none" } : style} >Email address format is invalid</div>
            </>}
        </>
    );
};